import {connect} from 'formik'
import {formatCents} from 'shared'

export const MatchingFundBanner = connect(({formik, display, config}) => {
  if (!config.showMatchingFund) return null

  const amountCents = formik.values.amount_cents
  const matchingCents = Math.min(amountCents, display.matchingFundLimitCents)
  const limitModifier = amountCents > matchingCents ? '_with_limit' : ''
  const totalCents = amountCents + matchingCents
  const i18nParams = {
    total_amount_tag: `<span>${formatCents(totalCents)}</span>`,
    company_name: display.matchingFundCompanyName,
    donation_amount_tag: formatCents(amountCents),
    matching_amount_tag: formatCents(matchingCents),
    matching_limit_amount: formatCents(display.matchingFundLimitCents)
  }

  const bannerText = I18n.t(`donate.matching_fund_banner.${config.wording}_text${limitModifier}`, i18nParams)

  return (
    <div className='donation-matching-fund-banner'>
      <p dangerouslySetInnerHTML={{ __html: bannerText }} />
    </div>
  )
})
